import CreditCardIcon from '@mui/icons-material/CreditCard';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class CreditCardBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.CreditCard;

  get Icon(): React.ComponentType<SvgIconProps> {
    return CreditCardIcon;
  }
}
